import { useState } from "react";
import { Clock, Trash2, Video as VideoIcon, Music, Layers } from "lucide-react";
import { thumbnailUrl } from "../lib/api";

const STATUS_STYLES = {
  completed: "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20",
  failed: "bg-red-500/10 text-red-400 border border-red-500/20",
  pending: "bg-slate-800 text-slate-400 border border-slate-700",
};

const activeStatuses = ["script", "voiceover", "visuals", "assembly"];

export const ProjectCard = ({ project, onOpen, onDelete }) => {
  const [imgError, setImgError] = useState(false);
  const isActive = activeStatuses.includes(project.status);
  const badgeClass = STATUS_STYLES[project.status] || "bg-amber-500/10 text-amber-400 border border-amber-500/20 animate-pulse";

  return (
    <div
      data-testid="project-card-item"
      onClick={() => onOpen(project.id)}
      className="group cursor-pointer bg-gradient-to-b from-slate-900/80 to-slate-950/80 border border-slate-800 rounded-2xl overflow-hidden hover:border-amber-500/40 hover:shadow-2xl hover:shadow-amber-500/10 transition-all"
    >
      <div className={`relative bg-slate-950 ${project.orientation === "shorts" ? "aspect-[9/16]" : "aspect-video"} flex items-center justify-center`}>
        {project.status === "completed" && !imgError ? (
          <img
            src={thumbnailUrl(project.id)}
            alt={project.title || project.topic}
            onError={() => setImgError(true)}
            className="w-full h-full object-cover"
          />
        ) : (
          <VideoIcon className="w-8 h-8 text-slate-700" />
        )}
        {isActive && (
          <div className="absolute inset-0 bg-slate-950/50 flex items-center justify-center">
            <Clock className="w-6 h-6 text-amber-400 animate-pulse" />
          </div>
        )}
        {project.kind === "song" && (
          <span
            data-testid="song-badge"
            className={`absolute top-2 left-2 flex items-center gap-1 text-black text-[10px] font-mono font-semibold px-2 py-0.5 rounded-full ${
              project.song_type === "rhyme" ? "bg-teal-400/90" : "bg-fuchsia-500/90"
            }`}
          >
            <Music className="w-3 h-3" />{" "}
            {project.song_type === "bhajan" ? "BHAJAN" : project.song_type === "rhyme" ? "RHYME" : "SONG"}
          </span>
        )}
        {project.kind === "compilation" && (
          <span
            data-testid="compilation-badge"
            className="absolute top-2 left-2 flex items-center gap-1 bg-indigo-400/90 text-black text-[10px] font-mono font-semibold px-2 py-0.5 rounded-full"
          >
            <Layers className="w-3 h-3" /> COMPILATION
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading font-semibold text-slate-100 text-sm line-clamp-2 mb-2">
          {project.title || project.topic}
        </h3>
        <div className="flex items-center justify-between">
          <span data-testid="project-status-badge" className={`px-2.5 py-1 rounded-full text-[10px] font-mono uppercase ${badgeClass}`}>
            {project.status}
          </span>
          <button
            data-testid="delete-project-button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(project.id);
            }}
            className="text-slate-500 hover:text-red-400 transition-colors"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
